import { render, staticRenderFns } from "./BuildingnoIndex.vue?vue&type=template&id=0a71d392&scoped=true&"
import script from "./BuildingnoIndex.vue?vue&type=script&lang=js&"
export * from "./BuildingnoIndex.vue?vue&type=script&lang=js&"
import style0 from "./BuildingnoIndex.vue?vue&type=style&index=0&id=0a71d392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a71d392",
  null
  
)

export default component.exports